var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5603 10.94C16.8412 11.2212 16.999 11.6025 16.999 12C16.999 12.3975 16.8412 12.7787 16.5603 13.06L10.9043 18.718C10.6229 18.9992 10.2413 19.1572 9.84349 19.1571C9.64649 19.1571 9.45143 19.1182 9.26944 19.0428C9.08746 18.9673 8.92211 18.8568 8.78284 18.7175C8.64358 18.5781 8.53312 18.4127 8.45777 18.2307C8.38243 18.0487 8.34367 17.8536 8.34372 17.6566C8.34376 17.4596 8.38261 17.2646 8.45804 17.0826C8.53347 16.9006 8.64401 16.7352 8.78334 16.596L13.3783 12L8.78234 7.40398C8.63901 7.26567 8.52466 7.10021 8.44596 6.91724C8.36727 6.73427 8.3258 6.53746 8.32397 6.3383C8.32215 6.13913 8.36001 5.94159 8.43534 5.75721C8.51068 5.57283 8.62198 5.4053 8.76275 5.2644C8.90352 5.1235 9.07095 5.01204 9.25525 4.93653C9.43956 4.86102 9.63706 4.82298 9.83623 4.82461C10.0354 4.82625 10.2322 4.86753 10.4153 4.94606C10.5983 5.02458 10.7639 5.13878 10.9023 5.28198L16.5623 10.94H16.5603Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7430c9882b35151e4ddb624cf080a04a.svg";
export { ForwardRef as ReactComponent };